<template>
    <div style="margin-bottom: -17px">
        <div>
            <a-space>
                <a-button :disabled="!completed" @click="closeUpload" icon="upload" type="primary">继续上传</a-button>
                <a-button :disabled="completed" :loading="canceling" @click="()=>this.canceling=true" icon="stop" type="danger">取消上传</a-button>
            </a-space>
            <a-button :disabled="!completed || !failure.length" @click="retryUpload" icon="sync" shape="round" style="float:right;" type="dashed">失败重试</a-button>
        </div>
        <a-alert type="warning" :show-icon="true" style="margin-top: 10px;">
            <template #message>
                上传过程中，请勿刷新或关闭页面，否则上传会被中断且列表会被清空
            </template>
        </a-alert>
        <a-tabs v-model="tabKey" :tab-bar-gutter="5" :animated="false">
            <a-tab-pane :key="1">
                <template #tab>待传 / {{files.length-passCount}}</template>
                <template v-for="item in upload">
                    <UploadItem :key="item.index" :item="item" :percent="item.percent" status="normal"/>
                </template>
            </a-tab-pane>
            <a-tab-pane :key="2">
                <template #tab>跳过 / {{skipped.length}}</template>
                <UploadItems :items="skipped" :height="tabHeight" status="success"/>
            </a-tab-pane>
            <a-tab-pane :key="3">
                <template #tab>覆盖 / {{override.length}}</template>
                <UploadItems :items="override" :height="tabHeight" status="success"/>
            </a-tab-pane>
            <a-tab-pane :key="4">
                <template #tab>成功 / {{success.length}}</template>
                <UploadItems :items="success" :height="tabHeight" status="success"/>
            </a-tab-pane>
            <a-tab-pane :key="5">
                <template #tab>失败 / {{failure.length}}</template>
                <UploadItems :items="failure" :height="tabHeight" status="exception"/>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
    import oss from "../../../../../utils/oss";
    import func from "../../../../../utils/func";
    import enums from "../../../../../utils/enums";
    import UploadItem from "./UploadItem";
    import UploadItems from "./UploadItems";

    export default {
        name: "UploadTable",
        components: {UploadItem, UploadItems},
        props: {
            albumId: {type: String},
            resizeLong: {type: Number},
        },
        data() {
            return {
                files: [],
                params: {},
                tabKey: 1,
                upload: [],
                skipped: [],
                override: [],
                success: [],
                failure: [],
                finishNum: 0,
                completed: false,
                canceling: false,
                quantity: window.IS_ELECTRON ? 8 : 4,
            }
        },
        computed: {
            tabHeight() {
                return this.$store.getters["layout/contentHeight"] - 165;
            },
            passCount() {
                return this.success.length + this.override.length
                    + this.failure.length + this.skipped.length;
            }
        },
        methods: {
            startUpload(files, params) {
                this.upload = [];
                this.failure = [];
                this.success = [];
                this.skipped = [];
                this.override = [];
                this.files = files;
                this.params = params;
                this.runUpload();
            },
            retryUpload() {
                this.failure = [];
                this.runUpload();
            },
            closeUpload() {
                let failed = this.failure.length > 0;
                if (this.completed && !failed) this.$emit("complete");
                else {
                    const self = this;
                    let message = failed ? "存在上传失败" : "上传还未完成";
                    self.$confirm({
                        title: "关闭确认",
                        content: `${message}，确认要关闭吗？`,
                        onOk() {
                            if (!self.completed)
                                self.canceling = true;
                            self.$emit("complete");
                        }
                    });
                }
            },
            runUpload() {
                this.tabKey = 1;
                this.finishNum = 0;
                this.completed = false;
                this.canceling = false;
                for (let i = 0; i < this.quantity; i++)
                    this.safeUpload(i);
            },
            safeUpload(index) {
                if (index >= this.files.length) {
                    return this.untilFinished();
                }
                let file = this.files[index];
                if (func.boolStrict(file.upload)) {
                    this.safeUpload(file.index + this.quantity);
                }
                else if (file.skip) this.setSuccess(file);
                else if (this.canceling) this.setFailure(file);
                else this.doUpload(file);
            },
            async doUpload(file) {
                file.percent = 10; // progress
                this.upload[file.index % this.quantity] = file;
                if (file.return) this.ossUpload(file, file.handle);
                else {
                    file.percent = 20; // progress
                    let max = (file.type === enums.Upload.TypeHD) ? this.resizeLong : 0;
                    oss.resize(file.handle, max)
                        .then(data => this.ossUpload(file, data))
                        .catch(err => this.setFailure(file, err));
                }
            },
            ossUpload(file, handle) {
                let args = {
                    type: file.type, // 上传类型
                    orient: "0", // 旋转方向
                    file_name: file.name, // 图片名称
                    catch_time: file.time, // 拍摄时间
                    relate_id: file.relate_id, // 关联已上传ID
                    retouch: this.params.retouch.toString(), // 是否已修图
                };
                let opts = {
                    parallel: 2,
                    partSize: Math.max(Math.ceil(handle.size / 2), 102400),
                    progress: (percentage) => file.percent = Math.max(30, Math.floor(percentage * 100)),
                };
                file.percent = 30;
                oss.upload(this.albumId, this.params.member_id, handle, args, opts)
                    .then(() => this.setSuccess(file))
                    .catch(err => this.setFailure(file, err));
            },
            setSuccess(file) {
                file.upload = true;
                this.safeUpload(file.index + this.quantity);
                if (file.skip) this.skipped.push(file);
                else if (file.relate_id) this.override.push(file);
                else this.success.push(file);
            },
            setFailure(file, err) {
                this.safeUpload(file.index + this.quantity);
                this.failure.push(file);
                func.isDefined(err) && console.log(err);
            },
            untilFinished() {
                this.finishNum += 1;
                if (this.finishNum >= this.quantity) {
                    this.upload = [];
                    this.completed = true;
                    this.canceling = false;
                }
            },
        }
    }
</script>
